import { render, staticRenderFns } from "./CountersignDepartmentSelect.vue?vue&type=template&id=6c280312&scoped=true"
import script from "./CountersignDepartmentSelect.vue?vue&type=script&lang=js"
export * from "./CountersignDepartmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c280312",
  null
  
)

export default component.exports